import { ShopRendererDraftApiClient } from '@fourthwall/services/dist/ShopRendererDraftApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateDraftMutation = createMutationHook(ShopRendererDraftApiClient.createDraft, {
  mutationKey: ['createDraft'],
})
